import { useState } from 'react'
import { MeetingParticipant, MeetingParticipantStatus } from '../../modules/meeting/model'
import ParticipantModal from './ParticipantModal'
import { getInitials } from '../../shared/helpers/getInitials'
import { getParticipantStatus } from '../../modules/meeting/model/meetingHelpers'

const ParticipantsList: React.FC<{
  participants: MeetingParticipant[]
  isLoading: boolean
  error?: string | null
}> = ({ participants, isLoading, error }) => {
  const [selectedParticipant, setSelectedParticipant] = useState<MeetingParticipant | null>(null)

  const handleParticipantClick = (participant: MeetingParticipant) => {
    setSelectedParticipant(participant)
  }

  const closeModal = () => {
    setSelectedParticipant(null)
  }

  const renderParticipantModal = () => {
    return <ParticipantModal selectedParticipant={selectedParticipant} closeModal={closeModal} />
  }

  return (
    <div className="flex flex-col gap-4">
      <h3 className="m-0 text-lg font-medium text-gray-900">
        Meeting Participants {participants.length > 0 && `(${participants.length})`}
      </h3>

      {isLoading && (
        <div className="rounded-lg bg-gray-100 p-2 text-center text-sm text-gray-600">
          Loading participant info...
        </div>
      )}

      {error && (
        <div className="rounded-lg bg-gray-100 p-2 text-center text-sm text-gray-600">
          Error: {error}
        </div>
      )}

      {!isLoading && !error && (!Array.isArray(participants) || participants.length === 0) && (
        <div className="rounded-lg bg-gray-100 p-2 text-center text-sm text-gray-600">
          No participants found
        </div>
      )}

      {Array.isArray(participants) && participants.length > 0 && (
        <div className="flex min-h-0 flex-col gap-2 overflow-y-auto">
          {participants.map((participant) => {
            const name = participant.screenName || participant.screenName || 'Unknown'
            const status = getParticipantStatus(participant)

            return (
              <div
                key={participant.participantUUID}
                className="flex cursor-pointer items-center gap-3 rounded-lg bg-gray-100 p-3 transition-all duration-200 ease-in-out hover:bg-gray-200"
                onClick={() => handleParticipantClick(participant)}
              >
                <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-blue-600 text-lg font-medium text-white">
                  {getInitials(name)}
                </div>
                <div className="min-w-0 flex-1">
                  <div className="mb-1 truncate text-lg font-medium text-gray-900">{name}</div>
                  <div className={`flex items-center gap-1 truncate text-sm text-gray-600`}>
                    {status.text}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      )}

      {renderParticipantModal()}
    </div>
  )
}

export default ParticipantsList
